import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ReactGA from 'react-ga4';
import { GA_MEASUREMENT_ID } from './config';

const GOOGLE_CLIENT_ID = '149860662868-aujicj4ru33ll7mptumimejq0nravv19.apps.googleusercontent.com'; // Updated with your ID

// Initialize Google Analytics
if (GA_MEASUREMENT_ID) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif', // Set Roboto as the primary font
  },
  components: {
    // Example: Default props for Button
    MuiButton: {
      defaultProps: {
        // variant: 'contained', // You could set a default variant here for all buttons
      },
    },
    // You can add more component customizations here
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
